document.addEventListener("DOMContentLoaded", function () {
    let previousCart = null;

    // Function to check if an item with _dynamicBoxId was removed or updated (quantity change)
    // function checkCartAfterUpdate(previousCart, currentCart) {
    //     let previousItems = previousCart.items;
    //     let currentItems = currentCart.items;

    //     // Find removed items
    //     let removedItems = previousItems.filter(prevItem =>
    //         !currentItems.some(currItem => currItem.id === prevItem.id)
    //     );

    //     // Check if any removed product had _dynamicBoxId
    //     let dynamicBoxItemRemoved = removedItems.some(item =>
    //         item.properties && item.properties._dynamicBoxId
    //     );

    //     // Check if any _dynamicBoxId item's quantity has changed
    //     let dynamicBoxItemUpdated = previousItems.some(prevItem => {
    //         let currentItem = currentItems.find(currItem => currItem.id === prevItem.id);
    //         return (
    //             currentItem &&
    //             prevItem.properties &&
    //             prevItem.properties._dynamicBoxId &&
    //             prevItem.quantity !== currentItem.quantity
    //         );
    //     });

    //     if (dynamicBoxItemRemoved || dynamicBoxItemUpdated) {
    //         fetch('/cart/clear.js', { method: 'POST' })
    //             .then(() => location.reload());
    //     }
    // }

function checkCartAfterUpdate(previousCart, currentCart) {
    let previousItems = previousCart.items || [];
    let currentItems = currentCart.items || [];

    let dynamicBoxItemRemoved = previousItems.some(prevItem =>
        prevItem.properties &&
        prevItem.properties._dynamicBoxId &&
        !currentItems.some(currItem => currItem.id === prevItem.id)
    );

    let dynamicBoxItemUpdated = previousItems.some(prevItem => {
        let currentItem = currentItems.find(currItem => currItem.id === prevItem.id);
        return (
            currentItem &&
            prevItem.properties &&
            prevItem.properties._dynamicBoxId &&
            prevItem.quantity !== currentItem.quantity
        );
    });

    if (dynamicBoxItemRemoved || dynamicBoxItemUpdated) {
        let updates = {};
        currentItems.forEach(item => {
            if (item.properties && item.properties._dynamicBoxId) {
                updates[item.id] = 0;
            }
        });

        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
        }).then(response => response.json())
          .then(data => {
              console.log("Cart updated:", data);
              location.reload();
          });
    }
}



    // Function to monitor cart updates (Flyout Cart - AJAX)
    function monitorCartUpdates() {
      console.log("called")
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => previousCart = cart);

        let cartContainer = document.querySelector('body');
        let observer = new MutationObserver(() => {
            fetch('/cart.js')
                .then(response => response.json())
                .then(newCart => {
                    if (previousCart) {
                        checkCartAfterUpdate(previousCart, newCart);
                    }
                    previousCart = newCart;
                });
        });

        observer.observe(cartContainer, { childList: true, subtree: true });
    }

    // Function to check for updates on the cart page (Full Page Refresh)
    function handleCartPageRefresh() {
        let storedCart = sessionStorage.getItem("previousCart");

        fetch('/cart.js')
            .then(response => response.json())
            .then(currentCart => {
                if (storedCart) {
                    let previousCart = JSON.parse(storedCart);
                    checkCartAfterUpdate(previousCart, currentCart);
                }
                sessionStorage.setItem("previousCart", JSON.stringify(currentCart)); // Store the latest cart state
            });
    }

    // Start monitoring for AJAX cart updates (Flyout Cart)
    monitorCartUpdates();

    // If we are on the cart page, store and compare cart states on page load
    if (window.location.pathname.includes('/cart')) {
        handleCartPageRefresh();
    }
});
